<app-text [alias]="'faculty_staff_code_edit_component'"></app-text>
<app-loading-wrapper [loading]="saving || !formGroup">
    <form *ngIf="questions" [formGroup]="formGroup">
        <app-question [question]="questions.staffCode"></app-question>
        <app-question [question]="questions.isEnabled"></app-question>
        <div class="margin-top-md">
            <app-button-list>
                <app-button #saveButton [loading]="saving" [disabled]="formGroup.invalid" (clickedEvent)="onSave()">Save </app-button>
            </app-button-list>
        </div>
    </form>
</app-loading-wrapper>
